import React, { useState, useEffect,useRef } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBath, faCamera, faImages, faMapMarkedAlt, faListAlt, faHeart, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import './shop-grid.css';
import './PropertyList.css';
import './productsliderV1.css';
import Slider from "rc-slider";
import { useLocation } from "react-router-dom";



const ProductDetails = ({ agentId }) => {
  
  const [products, setProducts] = useState([]);
  const [agent, setAgent] = useState(null);
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [isPriceFilterOpen, setIsPriceFilterOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [transactionType, setTransactionType] = useState('À vendre');
  const [category, setCategory] = useState('Résidentiel');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalProperties, setTotalProperties] = useState(32);
  const [activeTab, setActiveTab] = useState('sommaire');
  const [isResidentialOpen, setIsResidentialOpen] = useState(false);
  const [isRentOpen, setIsRentOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const location = useLocation(); // Use the useLocation hook

  const [priceRange, setPriceRange] = useState(location.state?.priceRange || [10000, 990000000]);


  const cardRef = useRef(null);
  const residentialDropdownRef = useRef(null);
  const rentDropdownRef = useRef(null);
  const dropdownRef = useRef(null);
  const filterModalRef = useRef(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const propertiesPerPage = 250;

  const handleResidentialClick = () => {
    setIsResidentialOpen(!isResidentialOpen);
    setIsRentOpen(false);
  };

  const handleRentClick = () => {
    setIsRentOpen(!isRentOpen);
    setIsResidentialOpen(false);
  };

  const handleClickOutside = (event) => {
    if (residentialDropdownRef.current && !residentialDropdownRef.current.contains(event.target)) {
      setIsResidentialOpen(false);
    }
    if (rentDropdownRef.current && !rentDropdownRef.current.contains(event.target)) {
      setIsRentOpen(false);
    }
    if (cardRef.current && !cardRef.current.contains(event.target)) {
      setIsPriceFilterOpen(false);
    }
    if (filterModalRef.current && !filterModalRef.current.contains(event.target)) {
      setIsFilterModalOpen(false);
    }
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (route) => {
    setIsOpen(false);
    navigate(route);
  };

  useEffect(() => {
    if (agentId) {
      const fetchAgentData = async () => {
        try {
          const response = await fetch(`https://keurgui-backend-kjour.ondigitalocean.app/agents/${agentId}`);
          if (!response.ok) {
            throw new Error(`Erreur HTTP: ${response.status}`);
          }
          const data = await response.json();
          setAgent(data);
          if (data?.agentName) {
            fetchAgentProperties(data.agentName, currentPage);
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des informations de l'agent :", error);
          setError(error.message);
        } finally {
          setLoading(false);
        }
      };
      fetchAgentData();
    }
  }, [agentId, currentPage]);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/search-predictive', {
          params: { query },
        });
        setSuggestions(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions', error);
      }
    };

    fetchSuggestions();
  }, [query]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products');
        setProducts(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des produits:', error);
      }
    };
    fetchProducts();
  }, []);

 // Charge les informations du produit
 useEffect(() => {
  axios
    .get(`https://keurgui-backend-kjour.ondigitalocean.app/api/products/${id}?populate=agent`)
    .then((response) => {
      console.log('Réponse du produit:', response.data);  // Vérifier la structure de la réponse
      setProduct(response.data);
      setLoading(false);
    })
    .catch((error) => {
      console.error("Erreur lors du chargement du produit:", error);
      setError(error.message);
      setLoading(false);
    });
}, [id]);

// Vérification de l'état de chargement et d'erreur
if (loading) {
  return <p>Chargement...</p>;
}

if (error) {
  return <p>Erreur: {error}</p>;
}
  const fetchAgentProperties = async (agentName, page) => {
    try {
      const response = await fetch(`https://keurgui-backend-kjour.ondigitalocean.app/api/products/agent/${agentName}?page=${page}&limit=4`);
      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des propriétés.");
      }
      const data = await response.json();
      setProducts(data.products);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error("🚨 Erreur lors de la récupération des propriétés :", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleTransactionChange = (e) => {
    const selectedType = e.target.value;
    setTransactionType(selectedType);
    if (selectedType === "À vendre") {
      navigate("/vendre");
    } else if (selectedType === "À louer") {
      navigate("/louer");
    }
  };

  const handleCardClick = (item) => {
    navigate(`/results/${encodeURIComponent(item)}`);
  };

  const handleButtonClick = () => {
    const phoneNumber = ""; // Replace with actual number
    const message = "Bonjour, je suis intéressé(e) par votre propriété.";
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  };

  const handleAgentClick = () => {
    if (product?.agent?._id) {
      navigate(`/agent-properties/${product.agent._id}`);
    }
  };

  const handleApplyFilter = async () => {
    try {
      console.log("Application du filtre avec la plage de prix :", priceRange);

      const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/filtre", {
        params: {
          minPrice: priceRange[0],
          maxPrice: priceRange[1],
          transactionType: "sale",
        },
      });

      setProducts(response.data);
      setIsPriceFilterOpen(false);
    } catch (error) {
      console.error("Erreur lors de l'application du filtre :", error);
    }
  };

  if (loading) {
    return <p>Chargement...</p>;
  }

  if (error) {
    return <p>Erreur: {error}</p>;
  }
  
  return (
    <div>
          <div className="ltn__product-area ltn__product-gutter mb-100">
            <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                  
                  <div className="tab-content ">
                    <div className="tab-pane fade active show" id="liton_product_grid">
                    <div className="ltn__product-tab-content-inner ltn__product-grid-view">
                      <div className="row">
                      
                      
   
    
   
    
          
    
                      {/* ltn__product-item */}
                      <div className="product-details-page">
          {/* En-tête avec titre et détails */}
          <div className="product-header">
            <div className="product-header-content">
              <div className="product-info-left">
                <h6>{product.title}</h6>
            
                <h5 className="address">
                  <FontAwesomeIcon icon={faMapMarkerAlt} /> {product.address}
                </h5>
              </div>
              <div className="product-info-center">
                <span className="price">{product.price} FCFA</span>
              </div>
    
              <div className="product-info-right">
              <button
      className="contact-agent-btn"
      onClick={handleButtonClick}
      style={{ backgroundColor: '#975d23', color: 'white' }} // Ajout de la couleur et du texte en blanc pour le contraste
    >
      Contacter le courtier immobilier
    </button>
    
              </div>
            </div>
          </div>
      <br/>
          {/* Galerie d'images */}
          
       <div className="product-gallery">
  {/* Grande image à gauche */}
  {product.images.length > 0 && (
    <div
      className="large-image"
      onClick={() => navigate(`/property-images/${product._id}`)}
      style={{ cursor: 'pointer' }}
    >
      <img src={product.images[0]} alt="Large Product" />
    </div>
  )}

  {/* Petites images à droite */}
  <div className="small-images">
    {product.images.slice(1, 5).map((image, index) => (
      <div
        key={index}
        onClick={() => navigate(`/property-images/${product._id}`)}
        style={{ cursor: 'pointer' }}
      >
        <img src={image} alt={`Small Product ${index + 1}`} />
      </div>
    ))}

    {/* Affichage de l'icône de la caméra */}
    {product.images.length > 0 && (
      <div
        className="icon-wrapper"
        onClick={() => navigate(`/property-images/${product._id}`)}
        style={{ cursor: 'pointer' }}
      >
        <FontAwesomeIcon icon={faCamera} className="photo-icon" />
        <span className="photo-count">{product.images.length}</span>
      </div>
    )}
  </div>
</div>

          <br />
          <div className="property-details">
          
<div className="features-container">
      <h2>Caractéristiques</h2>

  <div className="features-grid">

      <div className="feature">
          <p>
            <strong>Utilisation de la propriété :</strong>{" "}
            {product.propertyCategory === "commercial" ? "Commerciale" : "Résidentielle"}
          </p>
      </div>
      <div className="feature">
          <p>
            <strong>Superficie commerciale disponible :</strong>{" "}
            {product.features?.area ? `${product.features.area} pc` : "Non spécifié"}
          </p>
      </div>
      <div className="feature">
          <p>
            <strong>Superficie du bâtiment (au sol) :</strong>{" "}
            {product.lotSize ? `${product.lotSize} pc` : "Non spécifié"}
          </p>
      </div>
      <div className="feature">
          <p>
            <strong>Nombre d’unités :</strong> Commercial ({product.features?.numberOfUnits || 1})
          </p>
      </div>
  </div>
</div>

          <h3>Description</h3>
          <p>{product.description}</p>
    <br/>
    <br/> 
    <h3>Courtier immobilier</h3>
    <div className="ltn-author-introducing clearfix">
    <div className="author-img" onClick={handleAgentClick} style={{ cursor: 'pointer' }}>
       <div className="author-img" onClick={handleAgentClick} style={{ cursor: 'pointer' }}>
  {product.agent?.photoProfil && (
   <img
  src={
    product.agent?.photoProfil
      ? product.agent.photoProfil.startsWith("http")
        ? product.agent.photoProfil
        : `https://keurgui-images.ams3.digitaloceanspaces.com/${product.agent.photoProfil}`
      : "assets/img/blog/author.jpg"
  }
  alt="Photo de l'agent"
/>
  )}
</div>
        </div>
  <div className="author-info">
    <h6>Agent Immobilier</h6>
    <h2>{product.agent ? product.agent.agentName : "Nom inconnu"}</h2>
    <div className="footer-address">
      <ul>
        <li>
          <div className="footer-address-icon">
            <i className="icon-placeholder" />
          </div>
          <div className="footer-address-info">
            <p>{product.agent ? product.agent.territoire : "Localisation inconnue"}</p>
          </div>
        </li>
        <li>
          <div className="footer-address-icon">
            <i className="icon-call" />
          </div>
          <div className="footer-address-info">
            <p>
              <a href={`tel:${product.agent ? product.agent.phoneNumber : "+000-000000"}`}>
                {product.agent ? product.agent.phoneNumber : "Numéro inconnu"}
              </a>
            </p>
          </div>
        </li>
        <li>
          <div className="footer-address-icon">
            <i className="icon-mail" />
          </div>
          <div className="footer-address-info">
            <p>
              <a href={`mailto:${product.agent ? product.agent.email : "example@example.com"}`}>
                {product.agent ? product.agent.email : "Email inconnu"}
              </a>
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

        </div>
          {/* Détails supplémentaires */}
        
        </div>
                    
                      </div>
                    </div>
                    </div>
                    
                  </div>
                  
                  </div>
                </div>
            </div>
          </div>
                
          
    
    
          </div>
          )
          function getIndicatorPosition(tab) {
            switch (tab) {
              case 'galerie':
              return 0;
              case 'carte':
              return 33.33;
              case 'sommaire':
              return 66.66;
              default:
              return 0;
            }
            }
            
    }

export default ProductDetails;
